import { formatChangeHistoryDateTime } from './formatChangeHistoryDate';
import { HistoryGroupCardBody } from './HistoryGroupCardBody';
import type { HistoryChangeSetGroup, HistoryDisplayEntry } from './types';

export function HistoryGroupRow<T extends HistoryDisplayEntry>({
  group,
}: {
  group: HistoryChangeSetGroup<T>;
}) {
  const { date, time } = formatChangeHistoryDateTime(group.occurred_at);
  const timeLabel = `${date}, ${time}`;

  return (
    <li className="project-change-history-popover__item-slot">
      <div className="project-change-history-popover__item">
        <div className="project-change-history-popover__item-main">
          <HistoryGroupCardBody group={group} timeLabel={timeLabel} />
        </div>
      </div>
    </li>
  );
}
